import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { notifications } from 'app/core/notifications/notifications';
import { Subject, Subscription } from "rxjs";
import { IdentityService } from "./identity.service";
import { SecurityService } from "./security.service";

@Injectable()
export class NotificationService implements OnDestroy {
  private emitChangeSource = new Subject<any>();
  changeEmitted$ = this.emitChangeSource.asObservable();
  authSub: Subscription;

  constructor(
    private identityService: IdentityService,
    private securityService: SecurityService
  ) {
    setTimeout(() => this.showNotifications(), 1000);
    this.authSub = this.securityService.authenticationChallenge$.subscribe(() =>
      this.showNotifications()
    );
  }

  showNotifications() {
    this.showTermsOfServiceUpdate();
    this.showCookiePolicyConfirm();
  }

  showTermsOfServiceUpdate() {
    if (this.securityService.IsAuthorized) {
      const user = this.securityService.GetUser();
      if (!user.accepted_tos) {
        this.emitChangeSource.next(notifications.TOS);
      }
    }
  }

  termsOfServiceUpdateClose() {
    this.identityService.acceptTOS();
  }

  showCookiePolicyConfirm() {
    if (this.securityService.IsAuthorized) {
      const user = this.securityService.GetUser();
      if (!user.accepted_cookie) {
        this.emitChangeSource.next(notifications.Cookies);
      }
    }
  }

  cookiePolicyConfirmClose() {
    this.identityService.acceptCookiePolicy();
  }

  ngOnDestroy() {
    if (this.authSub) {
      this.authSub.unsubscribe();
    }
  }
}
